import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const menuCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'Menu',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.menus.`,
});

export async function getMenus(forceRefresh = false) {
	return menuCache.fetchOrCache('all', fetchMenusFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchMenusFromAPI() {
	// sidebar.js fetchMenuData(): applicationId 4 is the sales-force-automation webapp.
	const response = await authenticatedFetch(`${getApiUrl('Core/Menus')}?applicationId=4`, { method: 'GET' }, 'token');

	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const menus = await response.json();
	log('success', 'Menu', `✅ Fetched ${menus.length} menus`);
	return menus;
}

export async function refreshMenus() {
	menuCache.clearMemory();
	await menuCache.clear();
}
